import {
    Box,
    Button,
    CloseButton,
    createListCollection,
    Dialog,
    Field,
    Flex,
    Image,
    Input,
    InputGroup,
    Link,
    Select,
    Stack,
    Text,
    VStack,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import React, { useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { toaster } from "@/components/ui/toaster";
import { usePostFormMutation } from "@/hooks/microservicesApi";
import { emailRegex } from "@/utilities/text/regex";

const ContactModal = ({ isOpen, onClose }) => {
    const router = useRouter();
    const [nombre, setNombre] = useState("");
    const [apellidos, setApellidos] = useState("");
    const [telefono, setTelefono] = useState("");
    const [email, setEmail] = useState("");
    const [motivo, setMotivo] = useState("");
    const [motivo_exp, setMotivo_exp] = useState("");
    const [_emailError, setEmailError] = useState(false);
    const [_nombreError, setNombreError] = useState(false);
    const [_apellidoError, setApellidoError] = useState(false);
    const [_telefonoError, setTelefonoError] = useState("");
    const [postForm] = usePostFormMutation();

    const handleSubmit = () => {
        const body = {
            id: "5ccf4867-7379-4c52-9282-9b39cf885c7a",
            body: {
                fields: [
                    {
                        name: "firstname",
                        value: nombre,
                    },
                    {
                        name: "lastname",
                        value: apellidos,
                    },
                    {
                        name: "email",
                        value: email,
                    },
                    {
                        name: "phone",
                        value: telefono,
                    },
                    {
                        name: "motivo_de_contacto",
                        value: motivo,
                    },
                    {
                        name: "message",
                        value: motivo_exp,
                    },
                ],
                context: {
                    ipAddress: "3.14.97.137",
                    pageUri: "www.grupoguia.mx/contacto",
                    pageName: "Grupo Guia | Contacto",
                },
            },
        };

        postForm(body)
            .then((response) => {
                if (response.error) {
                    toaster.create({
                        title: "Error al enviar el formulario",
                        type: "error",
                        duration: 4000,
                        closable: true,
                        description: "Intenta nuevamente",
                    });
                } else {
                    router.push("/desarrollos/thankyoupage-contacto-gracias");
                }
            })
            .catch((error) => {
                console.error("Error: ", error);
            });
    };

    const frameworks = createListCollection({
        items: [
            { value: "Quiero vender mi propiedad", label: "Quiero vender mi propiedad" },
            { value: "Quiero rentar mi propiedad", label: "Quiero rentar mi propiedad" },
            { value: "Quiero comprar mi propiedad", label: "Quiero comprar mi propiedad" },
            {
                value: "Quiero invertir en bienes raíces",
                label: "Quiero invertir en bienes raíces",
            },
            { value: "Otros temas", label: "Otros temas" },
        ],
    });

    return (
        <Dialog.Root
            open={isOpen}
            onOpenChange={() => onClose()}
            size="sm"
            preventScroll
            placement="center"
        >
            <Dialog.Backdrop />
            <Dialog.Positioner>
                <Dialog.Content>
                    <Dialog.Header display="flex" justifyContent="center" pt={7}>
                        <Image
                            src="https://media.grupoguia.mx/assets/home-page/logos/logo-guia.webp"
                            alt="simple icon"
                            w={24}
                        />
                    </Dialog.Header>
                    <Dialog.CloseTrigger asChild>
                        <CloseButton />
                    </Dialog.CloseTrigger>
                    <Dialog.Body>
                        <Stack textAlign="center" alignItems="center">
                            <Text fontSize="xl" fontWeight={400} mt={6} color="#000">
                                ¡Completa tus datos
                            </Text>
                            <Text fontSize="xl" fontWeight={600} color="#000">
                                y encuentra el lugar para ti!
                            </Text>
                        </Stack>
                        <VStack
                            borderRadius="lg"
                            margin="auto"
                            mt={8}
                            maxW="100%"
                            py={12}
                            color="black"
                        >
                            <form
                                style={{ width: "80%" }}
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleSubmit();
                                }}
                            >
                                <Field.Root mb={3} invalid={_nombreError} gap={0} required>
                                    <Input
                                        onInvalid={() => setNombreError(true)}
                                        rounded="full"
                                        placeholder="Nombre(s)"
                                        marginBottom="10px"
                                        id="nombres"
                                        type="text"
                                        py={5}
                                        value={nombre}
                                        required
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setNombre(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setNombre(e.target.value);
                                            if (e.target.value.trim() === "") {
                                                setNombreError(true);
                                            } else {
                                                setNombreError(false);
                                            }
                                        }}
                                        _placeholder={{
                                            color: "#3C3C3C",
                                            fontSize: "md",
                                        }}
                                        px={4}
                                    />
                                    <Field.ErrorText ml="4" color="red.500">
                                        El nombre es necesario
                                    </Field.ErrorText>
                                </Field.Root>
                                <Field.Root mb={3} invalid={_apellidoError} gap={0} required>
                                    <Input
                                        onInvalid={() => setApellidoError(true)}
                                        rounded="full"
                                        placeholder="Apellidos"
                                        marginBottom="10px"
                                        value={apellidos}
                                        id="apellidos"
                                        type="text"
                                        py={5}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setApellidos(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setApellidos(e.target.value);
                                            if (e.target.value.trim() === "") {
                                                setApellidoError(true);
                                            } else {
                                                setApellidoError(false);
                                            }
                                        }}
                                        _placeholder={{
                                            color: "#3C3C3C",
                                            fontSize: "md",
                                        }}
                                        px={4}
                                    />
                                    <Field.ErrorText ml="4" color="red.500">
                                        El apellido es necesario
                                    </Field.ErrorText>
                                </Field.Root>
                                <Field.Root mb={3} invalid={_telefonoError} gap={0} required>
                                    <InputGroup
                                        marginBottom={2}
                                        borderLeftRadius="full"
                                        overflow="hidden"
                                        startAddon={
                                            <Flex
                                                gap={2}
                                                p={2}
                                                w="100%"
                                                h="100%"
                                                bg="#FFF"
                                                align="center"
                                                borderLeftRadius="full"
                                            >
                                                <Box backgroundColor="#FFFFFF" rounded="full">
                                                    <Image
                                                        src="https://media.grupoguia.mx/assets/home-page/icons/mexico.svg"
                                                        width="16px"
                                                        height="16px"
                                                        alt="mexico"
                                                    />
                                                </Box>
                                                <Box
                                                    backgroundColor="#FFFFFF"
                                                    borderLeftColor="#FFFFFF"
                                                    borderRadius="0px"
                                                    padding="0px"
                                                    paddingRight="10px"
                                                    color="#000"
                                                >
                                                    +52
                                                </Box>
                                            </Flex>
                                        }
                                    >
                                        <Input
                                            onInvalid={() => setTelefonoError(true)}
                                            borderRadius="24px"
                                            placeholder="Teléfono"
                                            type="number"
                                            id="telefono"
                                            py={5}
                                            value={telefono}
                                            onChange={(e) => {
                                                e.preventDefault();
                                                setTelefono(e.target.value);
                                                if (
                                                    e.target.value.trim() === "" ||
                                                    e.target.value.length < 10
                                                ) {
                                                    setTelefonoError(true);
                                                } else {
                                                    setTelefonoError(false);
                                                }
                                            }}
                                            onBlur={(e) => {
                                                e.preventDefault();
                                                setTelefono(e.target.value);
                                                if (
                                                    e.target.value.trim() === "" ||
                                                    e.target.value.length < 10
                                                ) {
                                                    setTelefonoError(true);
                                                } else {
                                                    setTelefonoError(false);
                                                }
                                            }}
                                            _placeholder={{
                                                color: "#3C3C3C",
                                                fontSize: "md",
                                            }}
                                            px={4}
                                        />
                                    </InputGroup>
                                    <Field.ErrorText ml="4" color="red.500">
                                        El teléfono no es válido
                                    </Field.ErrorText>
                                </Field.Root>
                                <Field.Root mb={3} invalid={_emailError} gap={0} required>
                                    <Input
                                        onInvalid={() => setEmailError(true)}
                                        rounded="full"
                                        placeholder="Correo electrónico"
                                        marginBottom="10px"
                                        value={email}
                                        id="email"
                                        type="email"
                                        py={5}
                                        required
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setEmail(e.target.value);
                                            setEmailError(!emailRegex.test(e.target.value));
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setEmail(e.target.value);
                                            if (!emailRegex.test(e.target.value)) {
                                                setEmailError(true);
                                            } else {
                                                setEmailError(false);
                                            }
                                        }}
                                        _placeholder={{
                                            color: "#3C3C3C",
                                            fontSize: "md",
                                        }}
                                        px={4}
                                    />
                                    <Field.ErrorText ml="4" color="red.500">
                                        La dirección de correo no es válida
                                    </Field.ErrorText>
                                </Field.Root>
                                <Field.Root mb={3} required gap={0} invalid={motivo === ""}>
                                    <Select.Root
                                        collection={frameworks}
                                        rounded="full"
                                        value={motivo == "" ? [] : [motivo]}
                                        id="motivo_contacto"
                                        py={2}
                                        onValueChange={(details) => {
                                            setMotivo(details.value[0]);
                                        }}
                                    >
                                        <Select.HiddenSelect />
                                        <Select.Control>
                                            <Select.Trigger pl={4} rounded="full">
                                                <Select.ValueText
                                                    placeholder="Motivo de contacto"
                                                    overflowWrap="break-word"
                                                    whiteSpace="normal"
                                                    color="gray.600"
                                                />
                                            </Select.Trigger>
                                            <Select.IndicatorGroup pr={4}>
                                                <Select.Indicator />
                                            </Select.IndicatorGroup>
                                        </Select.Control>
                                        <Select.Positioner>
                                            <Select.Content p={2}>
                                                {frameworks.items.map((framework) => (
                                                    <Select.Item
                                                        item={framework}
                                                        key={framework.value}
                                                        color="gray.600"
                                                        p={1}
                                                    >
                                                        <Select.ItemText>
                                                            {framework.label}
                                                        </Select.ItemText>
                                                        <Select.ItemIndicator />
                                                    </Select.Item>
                                                ))}
                                            </Select.Content>
                                        </Select.Positioner>
                                    </Select.Root>
                                    <Field.ErrorText ml="4" color="red.500">
                                        El motivo de contacto es necesario
                                    </Field.ErrorText>
                                </Field.Root>

                                <Field.Root mb={3}>
                                    <Input
                                        onInvalid={() => setEmailError(true)}
                                        rounded="full"
                                        placeholder="Motivo de contacto"
                                        marginBottom="10px"
                                        value={motivo_exp}
                                        id="motivo_exp"
                                        type="text"
                                        py={5}
                                        required
                                        disabled={motivo === "Otros temas" ? false : true}
                                        onChange={(e) => {
                                            e.preventDefault();
                                            setMotivo_exp(e.target.value);
                                        }}
                                        onBlur={(e) => {
                                            e.preventDefault();
                                            setMotivo_exp(e.target.value);
                                        }}
                                        _placeholder={{
                                            color: "#3C3C3C",
                                            padding: 4,
                                            fontSize: "md",
                                        }}
                                    />
                                </Field.Root>

                                <Button
                                    rounded="full"
                                    w="100%"
                                    fontWeight="500"
                                    color="black"
                                    borderColor="#FFCD00"
                                    bg="#FFCD00"
                                    _hover={{
                                        bg: "#EDBE00",
                                    }}
                                    type="submit"
                                >
                                    Enviar
                                </Button>
                                <VStack alignItems="center" mt="4">
                                    <Checkbox
                                        required
                                        size="sm"
                                        colorPalette="yellow"
                                        color="black"
                                    >
                                        Acepto los{" "}
                                        <Link
                                            textDecoration="underline"
                                            color="blue.600"
                                            href="/terminosycondiciones"
                                            external
                                        >
                                            {" "}
                                            Términos y condiciones.{" "}
                                        </Link>
                                    </Checkbox>
                                </VStack>
                            </form>
                        </VStack>
                    </Dialog.Body>
                </Dialog.Content>
            </Dialog.Positioner>
        </Dialog.Root>
    );
};

export default ContactModal;
